<script lang="ts">
	import { format } from 'svelte-i18n';
	import { onMount } from 'svelte';
	import type { IAlarmZone } from '../alarm_object';
	import PinLockAlarm from '../PinLockAlarm.svelte';
	import { Container, Text, Input, ButtonGroup, Button, Toggle } from '@Shelly/shelly-design-system';
	import { capFirstChar } from '../../../../helpers/utilities';
	import {
		getAlarmNotificationMessage,
		setAlarmNotificationMessage,
	} from '../../helpers/alarm_notification_message';

	export let alarm_object: IAlarmZone = {};
	export let inputAlarmMessegRef: HTMLInputElement;

	export let isActivityLogCheck: boolean;

	let message = getAlarmNotificationMessage(alarm_object);

	const toggle_activity_log_check = () => {
		isActivityLogCheck = !isActivityLogCheck;
	};

	const update_message = (e: Event) => {
		const value = (e.target as HTMLInputElement | null)?.value ?? message;
		message = value;
		setAlarmNotificationMessage(alarm_object, value);
	};

	onMount(() => {
		//alarm_object._id is check if the scene is edited
		if (!alarm_object._id) {
			isActivityLogCheck = true;
		} else {
			isActivityLogCheck =
				alarm_object &&
				alarm_object?.do.some(({ notify }) => {
					return typeof notify !== 'undefined' && notify === 'event_log';
				});
		}
	});
</script>

<Container padding="scrollPaddings">
	<Text element="h2" class="mb-s">
		{capFirstChar($format('alarm_state', { default: 'Alarm state' }))}
	</Text>

	<ButtonGroup
		id="buttongroup-juhb9c0"
		aria-label={$format('alarm_state', { default: 'Alarm state' })}
	>
		<Button
			class={alarm_object._enabled ? 'active' : undefined}
			size="m"
			leftIconSize="xs"
			on:click={() => {
				alarm_object._enabled = true;
			}}
		>
			{capFirstChar($format('alarm_armed', { default: 'Armed' }))}
		</Button>
		<Button
			class={!alarm_object._enabled ? 'active' : undefined}
			size="m"
			leftIconSize="xs"
			on:click={() => {
				alarm_object._enabled = false;
			}}
		>
			{capFirstChar($format('alarm_disarmed', { default: 'Disarmed' }))}
		</Button>
	</ButtonGroup>

	<hr class="mt-l mb-l" />

	<Text class="" element="h2">
		{capFirstChar(
			$format('alarm_message_placeholder', {
				default: 'Notification message',
			}),
		)}
	</Text>
	<Input
		id="input-notification-message"
		class="mt-s"
		bind:ref={inputAlarmMessegRef}
		label={capFirstChar(
			$format('alarm_message_placeholder', {
				default: 'Notification message',
			}),
		)}
		aria-labelledby="input-notification-message"
		bind:value={message}
		info={$format('wizard_input_info_example_alarm_message', {
			default: `Example: Motion detected!`,
		})}
		error={typeof message === 'undefined' || message.length === 0 || !message.trim()
			? $format('input_error_enter_alarm_message', {
					default: 'Please enter an alarm message',
				})
			: ''}
		size="m"
		icon="fas fa-bell"
		on:input={(e) => update_message(e)}
	/>

	<hr class="mt-l mb-l" />
	<Text element="h2">
		{capFirstChar(
			$format('wizard_step_more_options', {
				default: 'More options',
			}),
		)}
	</Text>
	<Toggle
		id="toggle-add-to-log"
		class="mt-s"
		checked={isActivityLogCheck}
		size="m"
		on:click={() => toggle_activity_log_check()}
	>
		{capFirstChar(
			$format('collapse_title_add_event_log', {
				default: 'Add to activity log',
			}),
		)}
	</Toggle>
	<PinLockAlarm
		{alarm_object}
		on:checked={(e) => {
			alarm_object.pin_lock = e.detail;
		}}
	/>
</Container>
